<template>
  <Dropdown @on-click='clickEvent' class="drop-down-div">
    <a href="javascript:void(0)">
    	<Button :type="type||'primary'" v-if="label">
            {{label}}	
            <Icon :type="icon"></Icon>
        </Button>
      <Icon :type="icon" v-if="!label"/>
    </a>
    <DropdownMenu slot="list">
      <DropdownItem v-for="menu in menus" :name="JSON.stringify(menu)" :disabled="menu.disabled">
        <Icon :type="menu.icon"></Icon>
        {{menu.label}}
      </DropdownItem>
    </DropdownMenu>
  </Dropdown>
</template>
<script>
  export default {
    name: 'CsDropDown',
    props: {
      menus:{
        type: Array,
        default: function () {
          return []
        }
      },
      data:{
        type:Object,
        default:function () {
          return null
        }
      },
      icon:{
        type:String,
        default:'ios-more-outline'
      },
      click:{
        type:Function,
      },
      label:{
      	type:String
      },
      type:{
      	type:String
      }
    },
    methods: {
      clickEvent(menu) {
        var obj = JSON.parse(menu)
        if(!obj.disabled){
      		this.click(obj.action, this.data)
      	}
      }
    },
    mounted() {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/dropdown/CsDropDown.vue